<template>
    <div></div>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex';
export default {
    name: 'writeLetterTheme',
    props: {
        items: {
            type: Object,
            default: () => ([]),
        }
    },
    data: () => ({
		test: '',
        themes: {},
        regions: {},
        cityes: {},
        selectRegion: null,
        selectCity: null,
        regionFocus: false,
        cityFocus: false,
        ajaxProcessed: false,
        showForm: false,
        textRegion: "",
        textCity: "",
        sendFormCheck: false,
        confirmConsent: false,
        selectIdTheme: null,
        loading: false,
    }),
    created() {
        this.themes = this.items.themes;
        this.regions = this.items.regions;
        this.cityes = this.items.city;
    },
    mounted() {
		if (this.items.themes) {
			if (Object.keys(this.items.themes).find(key => this.items.themes[key].selected)) {
				this.showForm = true;
			}
		}
    },
    computed: {
        getRegions() {
            let regions = [];
            for (let key in this.regions) {
                if (this.textRegion != "") {
                    if (this.regions[key].NAME.toLowerCase().indexOf(this.textRegion.toLowerCase()) > -1) {
                        regions.push(this.regions[key]);
                    }
                } else {
                    regions.push(this.regions[key]);
                }
            }
            return regions;
        },
        getCities() {
            if (!this.selectRegion) {
                return [];
            }

            let citys = [];
            for (let key in this.cityes) {
                if (this.cityes[key].IBLOCK_SECTION_ID == this.selectRegion) {
                    if (this.textCity != "") {

                        if (this.cityes[key].NAME.toLowerCase().indexOf(this.textCity.toLowerCase()) > -1) {
                            citys.push(this.cityes[key]);
                        }
                    } else {
                        citys.push(this.cityes[key]);
                    }
                }
            }
            return citys;
        },
        ...mapGetters({
            getYandexSiteKey: 'getYandexSiteKey',
        })
    },
    watch: {},
    methods: {
        getTheme(event) {
			const select = event.target;
			if (!select) return
			if (parseInt(select.value) > 0) {
                this.selectIdTheme = parseInt(select.value);
				this.showForm = true;
			} else {
				this.showForm = false;
			}
            setTimeout(() => {
                setPhoneMask($('.mask-phone'));
				window.propMultipleAddButton();
            }, 1000)
        },
        onSendForm(e) {
            e.preventDefault();
            this.setYandexCaptchaCallback(this.sendRequest);
           this.sendForm(e);
        },
        sendForm(event) {
            event.preventDefault();
            const container = document.querySelector("#write_letter_popup form");
            container.classList.add("ajax_processed");

            this.sendFormCheck = true;
            let form = event.target.closest("form");
            let valid = true;


            form.querySelectorAll("input, textarea").forEach((input) => {
                if (input.closest(".form_row")) {
                    if (input.checkValidity()) {
                        input.closest(".form_row").classList.remove("error");
                        if (input.classList.contains("mask-phone") === true) {

                            let phone = input.value.match(/\d+/ig).join("");
                            if (phone.length < 11) {
                                input.closest(".form_row").classList.add("error");
                                valid = false;
                            }
                        }
                    } else {
                        input.closest(".form_row").classList.add("error");
                        valid = false;
                    }
                }
            });
            if (!this.selectCity) {
                valid = false;
                showHeaderMessage('Выберите город из списка', 'error');
                container.classList.remove("ajax_processed");
            }
            if (valid === true) {
                if (!window.smartCaptcha) return;
                window.smartCaptcha.reset();
                window.smartCaptcha.execute();
                return;
            }
            return false;
        },
        sendRequest() {
            this.loading = true;
            let form = document.getElementById('write_letter');
            if (!form) return;
            let formData = new FormData(form)
            formData.append("ajax_command", "addForm");
            formData.append("z", true);
            formData.append("yatoken", window.smartCaptcha.getResponse());

            fetch("/local/php_interface/ajax/", {
                method: 'POST',
                body: formData
            }).then(
                response => {
                    response.json().then(answer => {
                        if (answer.success == true) {
                            window.$.fancybox.close();
                            showHeaderMessage(this.items.messageAdd, 'success');
                            form.querySelectorAll("input,textarea").forEach((input) => {
                                if (
                                    input.getAttribute('type') == "text"
                                    || input.getAttribute("type") == "tel"
                                    || input.getAttribute("type") == "email"
                                    || input.getAttribute("type") == "file"
                                ) {
                                    input.value = "";
                                }
                                form.classList.remove("ajax_processed");
                            });
                        } else {
                            if (answer.error) {
                                form.classList.remove("ajax_processed");
                                showHeaderMessage(answer.error, 'error');
                                
                            }
                        }
                    });
                },
            );
            this.loading = false;
            form.classList.remove("ajax_processed");
        },
        setParam(par) {
            this[par] = true;
        },
        deleteParam(par) {
            let el = this;
            setTimeout(() => {
                el[par] = false;
            }, 300)
        },
        setRegion(region) {
            this.selectRegion = region.ID;
            this.textRegion = region.NAME;
        },
        setCity(city) {
            this.selectCity = city.ID;
            this.textCity = city.NAME;
        },
        listChangeKeyUp(param) {
            if (param == 'region') {
                this.selectRegion = false;
            } else if (param == 'city') {
                this.selectCity = false;
            }
        },
        ...mapMutations({
            'setYandexCaptchaCallback': 'setYandexCaptchaCallback',
        }),
        ...mapActions({
            'initYandexCaptcha': 'initYandexCaptcha',
        })
    },
}
</script>
